import { render, staticRenderFns } from "./Notions.vue?vue&type=template&id=1c625f6c&scoped=true"
import script from "./Notions.vue?vue&type=script&lang=js"
export * from "./Notions.vue?vue&type=script&lang=js"
import style0 from "./Notions.vue?vue&type=style&index=0&id=1c625f6c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c625f6c",
  null
  
)

export default component.exports